<div class="modal-header border-0 pb-0 align-items-center">
  <h5 class="modal-title mb-0">{{ t()["share.tabInvite"] }}</h5>
  <button
    type="button"
    class="btn-close ms-auto"
    aria-label="Close"
    (click)="activeModal.dismiss()"
  ></button>
</div>

<div class="modal-body pt-2">
  <section class="invite-content d-flex flex-column gap-3">
    <div>
      <label class="form-label fw-600 mb-2">{{
        t()["share.individualGroupAccess"]
      }}</label>
      <input
        type="text"
        class="form-control invite-search-input"
        [value]="query()"
        [placeholder]="t()['share.invitePlaceholder']"
        [attr.aria-label]="t()['share.inviteAria']"
        (input)="onQueryInput($event)"
      />
    </div>

    @if (loading()) {
      <div class="alert alert-info py-2 mb-0">
        {{ t()["share.loadingUsersRoles"] }}
      </div>
    } @else if (errorMessage()) {
      <div class="alert alert-danger py-2 mb-0">
        {{ errorMessage() }}
      </div>
    } @else {
      <div class="list-group invite-user-list">
        @if (!filteredUsers().length) {
          <div class="list-group-item text-muted small py-3">
            {{ t()["share.noUsersFound"] }}
          </div>
        } @else {
          @for (
            user of filteredUsers();
            track user.email + "-" + user.workspaceName + "-" + user.roleId
          ) {
            <div class="list-group-item invite-user-item">
              <div
                class="d-flex align-items-start justify-content-between gap-2"
              >
                <div class="min-w-0">
                  <div class="fw-600 text-truncate">
                    {{ user.userName || user.email }}
                  </div>
                  <div class="small text-muted text-truncate">
                    {{ user.email }}
                  </div>
                  <div class="small text-muted text-truncate">
                    {{ user.workspaceName }}
                  </div>
                </div>
                <span class="badge text-bg-light border fw-500 mt-1">{{
                  user.roleName
                }}</span>
              </div>
            </div>
          }
        }
      </div>
    }
  </section>
</div>

<div class="modal-footer border-0 pt-2">
  <button
    type="button"
    class="btn btn-outline-primary"
    (click)="activeModal.dismiss()"
  >
    {{ t()["share.cancel"] }}
  </button>
</div>
